module.exports = __webpack_public_path__ + "img/content-black-icon.c76b786c.png";